module.exports = __webpack_public_path__ + "img/cross_white.b0c2c874.svg";